import React from "react";

export const Button = ({
  children,
  className = "",
  onClick,
  disabled = false,
  loading = false,
  variant = "primary",
  size = "default",
  fullWidth = false,
  type = "button",
  ...props
}) => {
  // Base styles
  const baseStyles =
    "flex items-center justify-center gap-2 p-2 relative rounded-[400px] font-raleway font-medium text-center tracking-[0] leading-[27px] whitespace-nowrap transition-all duration-200";

  // Variant styles
  const variants = {
    primary:
      "bg-[#A1F69E] text-[#010D0D] hover:bg-[#8FE48C] active:bg-[#7DD279]",
    secondary:
      "bg-white text-[#010D0D] border border-[#A1F69E] hover:bg-[#A1F69E] hover:text-[#010D0D]",
    outline:
      "bg-transparent text-[#A1F69E] border border-[#A1F69E] hover:bg-[#A1F69E] hover:text-[#010D0D]",
    ghost:
      "bg-transparent text-[#A1F69E] hover:bg-[#A1F69E] hover:bg-opacity-10",
    danger: "bg-red-500 text-white hover:bg-red-600 active:bg-red-700",
  };

  // Size styles
  const sizes = {
    small: "h-10 px-4 text-sm",
    default: "h-16 px-6 text-lg",
    large: "h-20 px-8 text-xl",
  };

  // Width styles
  const widthStyles = fullWidth ? "w-full" : "w-[343px]";

  // Disabled styles
  const disabledStyles = disabled
    ? "opacity-30 cursor-not-allowed"
    : "cursor-pointer";

  // Loading styles
  const loadingStyles = loading ? "cursor-wait" : "";

  const combinedClassName = `
    ${baseStyles}
    ${variants[variant] || variants.primary}
    ${sizes[size] || sizes.default}
    ${widthStyles}
    ${disabledStyles}
    ${loadingStyles}
    ${className}
  `
    .trim()
    .replace(/\s+/g, " ");

  const handleClick = (e) => {
    if (disabled || loading) return;
    onClick?.(e);
  };

  if (type === "button" || !type) {
    return (
      <div onClick={handleClick} className={combinedClassName} {...props}>
        {loading ? (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
            Загрузка...
          </div>
        ) : (
          children
        )}
      </div>
    );
  }

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled || loading}
      className={combinedClassName}
      {...props}
    >
      {loading ? (
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
          Загрузка...
        </div>
      ) : (
        children
      )}
    </button>
  );
};
